import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  inject,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { Article } from '../../../admin/shared/public-api';
import { ZoomDirective } from '../../directives/zoom.directive';
import { RatioDirective } from '../../directives/ratio.directive';
import { DeviceService } from '../../services/device.service';

@Component({
  selector: 'app-accomodation-card',
  templateUrl: './accomodation-card.component.html',
  styleUrls: ['./accomodation-card.component.scss'],
  imports: [RatioDirective, ZoomDirective, CommonModule, RouterModule],
})
export class AccomodationCardComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(ZoomDirective) zoomDirective: ZoomDirective;
  @ViewChild('wrapper') wrapper: ElementRef;

  @Input() accomodation: Article;
  @Input() small: boolean;
  @Input() ratioX: number;
  @Input() ratioY: number;

  protected deviceService = inject(DeviceService);
  articleImageSrc: string;
  observer: ResizeObserver;

  ngOnInit(): void {
    this.articleImageSrc = `
            linear-gradient(0deg, rgba(0, 0, 0, 0.7) 22%, rgba(0, 0, 0, 0) 35%),
            url("${this.accomodation?.coverPicture?.src.replace(/\\/g, '/')}")
            `;
  }

  ngAfterViewInit(): void {
    if (this.deviceService.isDesktop()) {
      this.observer = new ResizeObserver(() => {
        this.applyZoomDirective();
      });

      this.observer.observe(this.wrapper.nativeElement);
    }
  }

  ngOnDestroy(): void {
    if (this.deviceService.isDesktop() && this.observer) {
      this.observer.unobserve(this.wrapper.nativeElement);
    }
  }

  applyZoomDirective(): void {
    this.zoomDirective.setImageClass();
  }
}
